module.exports = __webpack_public_path__ + "img/envelope-32.c84d2aed.svg";